/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './CustomAssistantsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#getCustomAssistant
 */
export const GET_CUSTOM_ASSISTANT_QUERY_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_getCustomAssistant';
export const GET_CUSTOM_ASSISTANT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CUSTOM_ASSISTANT_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#listCustomAssistants
 */
export const LIST_CUSTOM_ASSISTANTS_QUERY_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_listCustomAssistants';
export const LIST_CUSTOM_ASSISTANTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_CUSTOM_ASSISTANTS_QUERY_FIELD_NAME,
  args: ['pageLength', 'searchTerm', 'filterByPermissions', 'authorName', 'filterByAuthor', 'sortField', 'sortDirection', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listCustomAssistantsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#createCustomAssistant
 */
export const CREATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_createCustomAssistant';
export const CREATE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['name', 'welcomeMessage', 'instructions', 'setUpInstructions', 'icon', 'description', 'status', 'enabledContext', 'conversationStarters', 'resources', 'enabledBuiltInTools', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#duplicateCustomAssistant
 */
export const DUPLICATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_duplicateCustomAssistant';
export const DUPLICATE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DUPLICATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.duplicateCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#updateCustomAssistant
 */
export const UPDATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_updateCustomAssistant';
export const UPDATE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id', 'name', 'welcomeMessage', 'instructions', 'setUpInstructions', 'icon', 'description', 'status', 'enabledContext', 'conversationStarters', 'resources', 'enabledBuiltInTools', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#deleteCustomAssistant
 */
export const DELETE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_deleteCustomAssistant';
export const DELETE_CUSTOM_ASSISTANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.deleteCustomAssistantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#installCustomAssistantTemplateFromGlobalId
 */
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_installCustomAssistantTemplateFromGlobalId';
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION_FIELD_NAME,
  args: ['templateGlobalId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.installCustomAssistantTemplateFromGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#lookupUserInstalledAssistantByGlobalId
 */
export const LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_lookupUserInstalledAssistantByGlobalId';
export const LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['globalId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.lookupUserInstalledAssistantByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#findAssistantsByResourceId
 */
export const FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_findAssistantsByResourceId';
export const FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY_FIELD_NAME,
  args: ['resourceType', 'resourceId', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.findAssistantsByResourceIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#submitPromptFeedback
 */
export const SUBMIT_PROMPT_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_customassistants_rpc_CustomAssistantsService_submitPromptFeedback';
export const SUBMIT_PROMPT_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_PROMPT_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['customAssistantId', 'customAssistantTemplateGlobalId', 'generatedPrompt', 'positive', 'explicit', 'feedback', 'correlationId'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.submitPromptFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});